

export const projects = [
    {
      img:"https://cdn.shopify.com/s/files/1/0052/7551/6995/products/Women_s-page-Skincare-Reveal-3rd.gif?v=1599636684" ,
      title: "FAB BAG",
      des: "FAB BAG is an E-commerce platform,Where they are building a destination where one can find the most comprehensive collection of the most beautiful, safe and effective beauty products in the world. In this project we have tried to make a look alike clone of FAB BAG. With our efforts and the technology stack, that we have learned so far in the masai school, we were able to clone the front end with high precision and quality.",
      demo: "",
      live: "https://priceless-heyrovsky-aaf112.netlify.app/",
      gitHub: "https://github.com/darkwingpatil/fabbag.git",
      technologies: ["HTML", "CSS", "JavaScript", "Localstorage", "Bootstrap"],
    },
    {
      img: "https://www.linkpicture.com/q/7557273_1606234814_nyka.jpg",
      title: "NYKAA",
      des: "Indian e-commerce website.It sells beauty, wellness and fashion products and you can also find best make-up brands,products of skin care and appliances also.",
      demo: "",
      live: "https://nykaa-clone-dusky.vercel.app/",
      gitHub: "https://github.com/Harapriyasahu/Hara_Nykaa-clone",
      technologies: ["HTML", "CSS", "JavaScript", "Localstorage", "Bootstrap"],
    },
  
    {
      img: "https://media.fashionnetwork.com/cdn-cgi/image/fit=contain,width=1000,height=1000/m/1344/418d/04c0/88c4/6950/f3e5/6972/e054/4e08/f126/f126.jpeg",
      title: "Meesho",
      des: "It is one of the largest social commerce platforms, especially in India in which anyone can start their online business. All a user needs to do is resell Meesho's products to your contacts.",
      demo: "",
      live: "https://meesho-by-nitrogen.netlify.app/",
      gitHub: "https://github.com/Harapriyasahu/MeeshoClone",
      technologies: ["HTML", "CSS", "JavaScript", "API","Localstorage"],
    },
    {
      img: "https://is1-ssl.mzstatic.com/image/thumb/Purple112/v4/a9/8e/cf/a98ecf6f-533e-dabc-b672-722829f69f66/AppIcon-0-0-1x_U007emarketing-0-0-0-5-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/1200x630wa.png",
      title: "Shine.com",
      des: "About shine.com is india's leading online job and recruitment portal - search & apply for latest job vacancies across top companies in india. user can register on this site by giving all details and user can can search and apply for jobs based on their skills and preferences.",
      demo: "",
      live: "https://superb-sundae-fd47f9.netlify.app/",
      gitHub: "https://github.com/Harapriyasahu/Shine-clone",
      technologies: ["React", "Redux", "Redux-Thunk","Backend", "uuid","Chakra"],
    },
  ];